module.exports = {
    domain: 'https://fudaojs.haofenshu.com',
    api: {
        base: 'https://hfsfd-teacher.haofenshu.com',
        captcha: 'https://hfs2-avatar.yunxiao.com',
        slideCaptcha: 'https://hfsfd3-captcha.haofenshu.com',
        message: 'https://fd-message.haofenshu.com',
        socket: 'https://fd-message.haofenshu.com',
        timeout: 60000
    },
    trackPoint: {
        feMonitor: '//fe-monitor.iyunxiao.com', // trackPonit 配置获取地址
        projectId: '5da5c6040000055362e3ac70', // 项目 ID
        baseURL: '//fe-monitor.iyunxiao.com', // 上报地址
        time: 5000, // 上报间隔
        sKey: 'FDJS_TrackPoint', // 本地 storge 缓存 key，可根据项目修改
        eventType: ['click', 'hover'] // 事件类型
    },
    imgService: {
        prefix: 'hfsfdjs'
    },
    cookie: {
        key: 'hfsfd-t-session-id',
        domain: '.haofenshu.com'
    },
    studentApi: {
        base: 'http://fudao.haofenshu.com'
    },
    coursewareUrl: 'https://courseware.haofenshu.com',
    env: 'production',
    wechat_zxs: 'http://activity.aipublish.cn/zxs'
};



// WEBPACK FOOTER //
// ./src/feConfig/production.js